"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __elasticsearch_1 = require("../../__elasticsearch");
const __enums_1 = require("../../__types/__enums");
const ReportingEnums_1 = require("../../__types/__enums/ReportingEnums");
const elasticsearchQuery_1 = require("../__common/elasticsearchQuery");
const getAggregation_1 = require("../contents/common/getAggregation");
const ILTRegisterType = {
    assigned: ReportingEnums_1.ILTRegisterTypeEnums.ASSIGNED,
    notRegistered: ReportingEnums_1.ILTRegisterTypeEnums.NOT_REGISTERED,
    waitListed: ReportingEnums_1.ILTRegisterTypeEnums.WAIT_LISTED,
    enrolled: ReportingEnums_1.ILTRegisterTypeEnums.ENROLLED
};
function getTotalUsersAndAggregratedResultFromEs(query, aggs) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const body = { query, aggs };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__enums_1.ElasticsearchIndicesUrlMapping.users);
        const esQuery = {
            index: __enums_1.ElasticsearchIndicesEnum.STATE,
            type: __enums_1.ElasticsearchTypesEnum.STATE,
            body: Object.assign({}, body, { size: 0 })
        };
        const result = yield elasticsearchClient.search(esQuery);
        const totalLearners = result.hits.total;
        return {
            totalLearners,
            aggregationBucket: result.aggregations.registerType.buckets
        };
    });
}
function findCompletedCountFromCompletionStatusAggregrate(completionStatusAggregrate) {
    const { buckets } = completionStatusAggregrate;
    const completedBucket = buckets.find((doc) => doc.key === __enums_1.CompletionStatusValuesEnum.COMPLETED);
    if (completedBucket) {
        return completedBucket.doc_count;
    }
    return 0;
}
function transformedResult(aggregationBucket, totalLearners) {
    const aggregateUser = [];
    let attendedCount = 0;
    aggregationBucket.map((bucket) => {
        const { key, doc_count, completionStatusAggregrate } = bucket;
        if (ILTRegisterType[key] === ReportingEnums_1.ILTRegisterTypeEnums.ASSIGNED ||
            ILTRegisterType[key] === ReportingEnums_1.ILTRegisterTypeEnums.ENROLLED) {
            attendedCount += findCompletedCountFromCompletionStatusAggregrate(completionStatusAggregrate);
        }
        aggregateUser.push({
            registerType: ILTRegisterType[key],
            userCount: doc_count
        });
    });
    aggregateUser.push({
        registerType: 'attended',
        userCount: attendedCount
    });
    return {
        total: totalLearners,
        aggregrate: aggregateUser
    };
}
function getUserAggregratedByRegisterType(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParams, ReportProjection = {} } = input;
        const { userContentMetricProjection } = ReportProjection;
        const customProjection = userContentMetricProjection && userContentMetricProjection.custom;
        const { filters } = reportParams;
        const query = elasticsearchQuery_1.getElasticsearchQueryFromFiltersAndSearch(filters.stateFilters);
        const aggs = getAggregation_1.getAggregationForRegisterTypeReport(customProjection);
        const { aggregationBucket, totalLearners } = yield getTotalUsersAndAggregratedResultFromEs(query, aggs);
        const result = transformedResult(aggregationBucket, totalLearners);
        return result;
    });
}
exports.getUserAggregratedByRegisterType = getUserAggregratedByRegisterType;
//# sourceMappingURL=getUserAggregratedByRegisterType.js.map